import React from 'react';

import './VerificationCodeForm.scss';
import images from '../../shared/assets/images';
import { validate, resetStyles } from '../../helpers/form';

const { formLogo } = images;

export default function VerificationCodeForm() {
  return (
    <section id="verificationCode">
      <div id="verificationCode_logo"><img alt="logo" src={formLogo} /></div>

      <h2 id="verificationCode_title">Verificatie code</h2>

      <p id="verificationCode_text">
        Je hebt een 6-cijferige verificatie code toegestuurd gekregen
        in een sms. Om jouw account te verifiëren moet je deze hieronder
        invullen. Na 15 minuten nog geen verificatie code ontvangen? <span>
        Stuur opnieuw</span>
      </p>

      <form
        autoComplete="off"
        name="verificationCode"
        id="verificationCode_form"
        onSubmit={e => verifyCode(e)}
        onKeyDown={e => resetStyles(e.target)}>

        <label htmlFor="verificationCode_code">
          Jouw 6-cijferige verificatie code
        </label>

        <input
          autoFocus
          type="text"
          name="code"
          placeholder="Code..."
          id="verificationCode_code"
        />

        <div id="verificationCode_button">
          <button tabIndex="0" type="submit">Verifieer</button>
        </div>
      </form>

      <div id="verificationCode_links">
        <p>Stuur opnieuw</p>
        <p>Veelgestelde vragen</p>
      </div>
    </section>
  );

  function verifyCode(e) {
    e.preventDefault();

    const isValidated = validate(document.verificationCode.code);

    if (!isValidated) return;

    // TODO: proceed verification process
  }
}

